import * as moment from 'vendors/moment-locale-th';

import { CartModel } from 'app/model/cart.model';

export class SearchFormModel {
  public destination: DestinationModel;
  public checkInDate: string;
  public checkOutDate: string;
  public guests: GuestModel[];
  public purpose: string;
  public radius: number;
  public breakfast: boolean;
  public securityStandard: boolean;
  public sanitizedStay: boolean;
  public freeCancellation: boolean;
  public overBudget: boolean;
  public campaignId?: number;

  constructor(cart: CartModel = undefined, lang: String = 'en', breakfast: boolean = false, securityStandard: boolean = false, sanitizedStay: boolean = false, freeCancellation: boolean = false, overBudget: boolean = false) {
    if (cart && cart.productDetail) {
        this.destination = new DestinationModel();
        this.destination.title = lang === 'th' ? cart.productDetail.destinationTitles.th.toString() : cart.productDetail.destinationTitles.en.toString();
        this.destination.id = cart.productDetail.destinationId.toString();
        this.checkInDate = moment.unix(cart.optionDetail.dateCheckIn.valueOf() / 1000).utc().format('DD-MM-YYYY');
        this.checkOutDate = moment.unix(cart.optionDetail.dateCheckOut.valueOf() / 1000).utc().format('DD-MM-YYYY');
        this.purpose = cart.purpose.toString();
        this.breakfast = breakfast;
        this.securityStandard = securityStandard;
        this.sanitizedStay = sanitizedStay;
        this.freeCancellation = freeCancellation;
        this.overBudget = overBudget;
    }
  }
}

export class GuestModel {
  public adult: number;
  public children: number[];

  constructor(adult?: number , children?: number[]) {
    this.adult = adult;
    this.children = children;
  }
}

export class DestinationModel {
  public title: string;
  public id: string;
  public suggestCat: string;
  public slug: string;
  public poi: PoiLocation;
  public destinationId?: string;
  public destinationTitle?: string;
  public type?: string;
}

export class PoiLocation {
  public lat: number;
  public lon: number;

  constructor(lat: number, lon: number) {
    this.lat = lat;
    this.lon = lon;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/search-form-model.ts